export class GameOver extends Phaser.Scene {
    constructor(level) {
        super({key: "game-over"});
        this._level = level
    }
    preload() {
        this.load.video("game-over", "assets/videos/game-over.mp4")
    }
    create() {
        this.sound.stopAll()
        this.add.video(0, 0, "game-over")
            .setOrigin(0, 0)
            .setScale(0.625)
            .play()
            .on("complete", () => this._level.reset())
    }
}